import $http from '@/api';

export default {
  async fetchDashboardSiteConfig(siteId) {
    return $http.get(`/api/dashboard/config/${siteId}`);
  },
};
